import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import {isActivateLendingAccount$} from '@/streams/config/lending';
import {userInfo$} from '@/streams/user';
import {wwData$} from '@/streams/worker-data';
import type {ULendingAccountStatus} from '@px/ws-data';

export const isSupportLending$ = userInfo$.pipe(
  filter((userInfo) => !!userInfo),
  map((userInfo) => userInfo.isMain),
  distinctUntilChanged()
);

export {isActivateLendingAccount$};

wwData$
  .pipe(
    filter((o) => o.type === 'update-lending-account-status'),
    map((o: ULendingAccountStatus): boolean => o.data && o.data.isActivateLendingAccount),
    distinctUntilChanged()
  )
  .subscribe((isActivateLendingAccount) => isActivateLendingAccount$.next(isActivateLendingAccount));
